webpackJsonp([3],{

/***/ "0w4T":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b9e3d714f42611eb31f421d72228b261.png";

/***/ }),

/***/ "Yk1m":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "409c1fc93e38b3ca2c47b95814da9a9d.png";

/***/ }),

/***/ "aFu/":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // CommonJS
    module.exports = factory();
  } else {
    // running in browser
    root.latinize = factory();
  }
})(this, function () {

  function latinize(str) {
    if (typeof str === 'string') {
      return str.replace(/[^A-Za-z0-9]/g, function (x) {
        return latinize.characters[x] || x;
      });
    } else {
      return str;
    }
  }

  latinize.characters = {
    'Á': 'A',
    'Ă': 'A',
    'Ắ': 'A',
    'Ặ': 'A',
    'Ằ': 'A',
    'Ẳ': 'A',
    'Ẵ': 'A',
    'Ǎ': 'A',
    'Â': 'A',
    'Ấ': 'A',
    'Ậ': 'A',
    'Ầ': 'A',
    'Ẩ': 'A',
    'Ẫ': 'A',
    'Ä': 'A',
    'Ǟ': 'A',
    'Ȧ': 'A',
    'Ǡ': 'A',
    'Ạ': 'A',
    'Ȁ': 'A',
    'À': 'A',
    'Ả': 'A',
    'Ȃ': 'A',
    'Ā': 'A',
    'Ą': 'A',
    'Å': 'A',
    'Ǻ': 'A',
    'Ḁ': 'A',
    'Ⱥ': 'A',
    'Ã': 'A',
    'Ꜳ': 'AA',
    'Æ': 'AE',
    'Ǽ': 'AE',
    'Ǣ': 'AE',
    'Ꜵ': 'AO',
    'Ꜷ': 'AU',
    'Ꜹ': 'AV',
    'Ꜻ': 'AV',
    'Ꜽ': 'AY',
    'Ḃ': 'B',
    'Ḅ': 'B',
    'Ɓ': 'B',
    'Ḇ': 'B',
    'Ƀ': 'B',
    'Ƃ': 'B',
    'Ć': 'C',
    'Č': 'C',
    'Ç': 'C',
    'Ḉ': 'C',
    'Ĉ': 'C',
    'Ċ': 'C',
    'Ƈ': 'C',
    'Ȼ': 'C',
    'Ď': 'D',
    'Ḑ': 'D',
    'Ḓ': 'D',
    'Ḋ': 'D',
    'Ḍ': 'D',
    'Ɗ': 'D',
    'Ḏ': 'D',
    'ǲ': 'D',
    'ǅ': 'D',
    'Đ': 'D',
    'Ƌ': 'D',
    'Ǳ': 'DZ',
    'Ǆ': 'DZ',
    'É': 'E',
    'Ĕ': 'E',
    'Ě': 'E',
    'Ȩ': 'E',
    'Ḝ': 'E',
    'Ê': 'E',
    'Ế': 'E',
    'Ệ': 'E',
    'Ề': 'E',
    'Ể': 'E',
    'Ễ': 'E',
    'Ḙ': 'E',
    'Ë': 'E',
    'Ė': 'E',
    'Ẹ': 'E',
    'Ȅ': 'E',
    'È': 'E',
    'Ẻ': 'E',
    'Ȇ': 'E',
    'Ē': 'E',
    'Ḗ': 'E',
    'Ḕ': 'E',
    'Ę': 'E',
    'Ɇ': 'E',
    'Ẽ': 'E',
    'Ḛ': 'E',
    'Ꝫ': 'ET',
    'Ḟ': 'F',
    'Ƒ': 'F',
    'Ǵ': 'G',
    'Ğ': 'G',
    'Ǧ': 'G',
    'Ģ': 'G',
    'Ĝ': 'G',
    'Ġ': 'G',
    'Ɠ': 'G',
    'Ḡ': 'G',
    'Ǥ': 'G',
    'Ḫ': 'H',
    'Ȟ': 'H',
    'Ḩ': 'H',
    'Ĥ': 'H',
    'Ⱨ': 'H',
    'Ḧ': 'H',
    'Ḣ': 'H',
    'Ḥ': 'H',
    'Ħ': 'H',
    'Í': 'I',
    'Ĭ': 'I',
    'Ǐ': 'I',
    'Î': 'I',
    'Ï': 'I',
    'Ḯ': 'I',
    'İ': 'I',
    'Ị': 'I',
    'Ȉ': 'I',
    'Ì': 'I',
    'Ỉ': 'I',
    'Ȋ': 'I',
    'Ī': 'I',
    'Į': 'I',
    'Ɨ': 'I',
    'Ĩ': 'I',
    'Ḭ': 'I',
    'Ꝺ': 'D',
    'Ꝼ': 'F',
    'Ᵹ': 'G',
    'Ꞃ': 'R',
    'Ꞅ': 'S',
    'Ꞇ': 'T',
    'Ꝭ': 'IS',
    'Ĵ': 'J',
    'Ɉ': 'J',
    'Ḱ': 'K',
    'Ǩ': 'K',
    'Ķ': 'K',
    'Ⱪ': 'K',
    'Ꝃ': 'K',
    'Ḳ': 'K',
    'Ƙ': 'K',
    'Ḵ': 'K',
    'Ꝁ': 'K',
    'Ꝅ': 'K',
    'Ĺ': 'L',
    'Ƚ': 'L',
    'Ľ': 'L',
    'Ļ': 'L',
    'Ḽ': 'L',
    'Ḷ': 'L',
    'Ḹ': 'L',
    'Ⱡ': 'L',
    'Ꝉ': 'L',
    'Ḻ': 'L',
    'Ŀ': 'L',
    'Ɫ': 'L',
    'ǈ': 'L',
    'Ł': 'L',
    'Ǉ': 'LJ',
    'Ḿ': 'M',
    'Ṁ': 'M',
    'Ṃ': 'M',
    'Ɱ': 'M',
    'Ń': 'N',
    'Ň': 'N',
    'Ņ': 'N',
    'Ṋ': 'N',
    'Ṅ': 'N',
    'Ṇ': 'N',
    'Ǹ': 'N',
    'Ɲ': 'N',
    'Ṉ': 'N',
    'Ƞ': 'N',
    'ǋ': 'N',
    'Ñ': 'N',
    'Ǌ': 'NJ',
    'Ó': 'O',
    'Ŏ': 'O',
    'Ǒ': 'O',
    'Ô': 'O',
    'Ố': 'O',
    'Ộ': 'O',
    'Ồ': 'O',
    'Ổ': 'O',
    'Ỗ': 'O',
    'Ö': 'O',
    'Ȫ': 'O',
    'Ȯ': 'O',
    'Ȱ': 'O',
    'Ọ': 'O',
    'Ő': 'O',
    'Ȍ': 'O',
    'Ò': 'O',
    'Ỏ': 'O',
    'Ơ': 'O',
    'Ớ': 'O',
    'Ợ': 'O',
    'Ờ': 'O',
    'Ở': 'O',
    'Ỡ': 'O',
    'Ȏ': 'O',
    'Ꝋ': 'O',
    'Ꝍ': 'O',
    'Ō': 'O',
    'Ṓ': 'O',
    'Ṑ': 'O',
    'Ɵ': 'O',
    'Ǫ': 'O',
    'Ǭ': 'O',
    'Ø': 'O',
    'Ǿ': 'O',
    'Õ': 'O',
    'Ṍ': 'O',
    'Ṏ': 'O',
    'Ȭ': 'O',
    'Ƣ': 'OI',
    'Ꝏ': 'OO',
    'Ɛ': 'E',
    'Ɔ': 'O',
    'Ȣ': 'OU',
    'Ṕ': 'P',
    'Ṗ': 'P',
    'Ꝓ': 'P',
    'Ƥ': 'P',
    'Ꝕ': 'P',
    'Ᵽ': 'P',
    'Ꝑ': 'P',
    'Ꝙ': 'Q',
    'Ꝗ': 'Q',
    'Ŕ': 'R',
    'Ř': 'R',
    'Ŗ': 'R',
    'Ṙ': 'R',
    'Ṛ': 'R',
    'Ṝ': 'R',
    'Ȑ': 'R',
    'Ȓ': 'R',
    'Ṟ': 'R',
    'Ɍ': 'R',
    'Ɽ': 'R',
    'Ꜿ': 'C',
    'Ǝ': 'E',
    'Ś': 'S',
    'Ṥ': 'S',
    'Š': 'S',
    'Ṧ': 'S',
    'Ş': 'S',
    'Ŝ': 'S',
    'Ș': 'S',
    'Ṡ': 'S',
    'Ṣ': 'S',
    'Ṩ': 'S',
    'ß': 'ss',
    'Ť': 'T',
    'Ţ': 'T',
    'Ṱ': 'T',
    'Ț': 'T',
    'Ⱦ': 'T',
    'Ṫ': 'T',
    'Ṭ': 'T',
    'Ƭ': 'T',
    'Ṯ': 'T',
    'Ʈ': 'T',
    'Ŧ': 'T',
    'Ɐ': 'A',
    'Ꞁ': 'L',
    'Ɯ': 'M',
    'Ʌ': 'V',
    'Ꜩ': 'TZ',
    'Ú': 'U',
    'Ŭ': 'U',
    'Ǔ': 'U',
    'Û': 'U',
    'Ṷ': 'U',
    'Ü': 'U',
    'Ǘ': 'U',
    'Ǚ': 'U',
    'Ǜ': 'U',
    'Ǖ': 'U',
    'Ṳ': 'U',
    'Ụ': 'U',
    'Ű': 'U',
    'Ȕ': 'U',
    'Ù': 'U',
    'Ủ': 'U',
    'Ư': 'U',
    'Ứ': 'U',
    'Ự': 'U',
    'Ừ': 'U',
    'Ử': 'U',
    'Ữ': 'U',
    'Ȗ': 'U',
    'Ū': 'U',
    'Ṻ': 'U',
    'Ų': 'U',
    'Ů': 'U',
    'Ũ': 'U',
    'Ṹ': 'U',
    'Ṵ': 'U',
    'Ꝟ': 'V',
    'Ṿ': 'V',
    'Ʋ': 'V',
    'Ṽ': 'V',
    'Ꝡ': 'VY',
    'Ẃ': 'W',
    'Ŵ': 'W',
    'Ẅ': 'W',
    'Ẇ': 'W',
    'Ẉ': 'W',
    'Ẁ': 'W',
    'Ⱳ': 'W',
    'Ẍ': 'X',
    'Ẋ': 'X',
    'Ý': 'Y',
    'Ŷ': 'Y',
    'Ÿ': 'Y',
    'Ẏ': 'Y',
    'Ỵ': 'Y',
    'Ỳ': 'Y',
    'Ƴ': 'Y',
    'Ỷ': 'Y',
    'Ỿ': 'Y',
    'Ȳ': 'Y',
    'Ɏ': 'Y',
    'Ỹ': 'Y',
    'Ź': 'Z',
    'Ž': 'Z',
    'Ẑ': 'Z',
    'Ⱬ': 'Z',
    'Ż': 'Z',
    'Ẓ': 'Z',
    'Ȥ': 'Z',
    'Ẕ': 'Z',
    'Ƶ': 'Z',
    'Ĳ': 'IJ',
    'Œ': 'OE',
    'ᴀ': 'A',
    'ᴁ': 'AE',
    'ʙ': 'B',
    'ᴃ': 'B',
    'ᴄ': 'C',
    'ᴅ': 'D',
    'ᴇ': 'E',
    'ꜰ': 'F',
    'ɢ': 'G',
    'ʛ': 'G',
    'ʜ': 'H',
    'ɪ': 'I',
    'ʁ': 'R',
    'ᴊ': 'J',
    'ᴋ': 'K',
    'ʟ': 'L',
    'ᴌ': 'L',
    'ᴍ': 'M',
    'ɴ': 'N',
    'ᴏ': 'O',
    'ɶ': 'OE',
    'ᴐ': 'O',
    'ᴕ': 'OU',
    'ᴘ': 'P',
    'ʀ': 'R',
    'ᴎ': 'N',
    'ᴙ': 'R',
    'ꜱ': 'S',
    'ᴛ': 'T',
    'ⱻ': 'E',
    'ᴚ': 'R',
    'ᴜ': 'U',
    'ᴠ': 'V',
    'ᴡ': 'W',
    'ʏ': 'Y',
    'ᴢ': 'Z',
    'á': 'a',
    'ă': 'a',
    'ắ': 'a',
    'ặ': 'a',
    'ằ': 'a',
    'ẳ': 'a',
    'ẵ': 'a',
    'ǎ': 'a',
    'â': 'a',
    'ấ': 'a',
    'ậ': 'a',
    'ầ': 'a',
    'ẩ': 'a',
    'ẫ': 'a',
    'ä': 'a',
    'ǟ': 'a',
    'ȧ': 'a',
    'ǡ': 'a',
    'ạ': 'a',
    'ȁ': 'a',
    'à': 'a',
    'ả': 'a',
    'ȃ': 'a',
    'ā': 'a',
    'ą': 'a',
    'ᶏ': 'a',
    'ẚ': 'a',
    'å': 'a',
    'ǻ': 'a',
    'ḁ': 'a',
    'ⱥ': 'a',
    'ã': 'a',
    'ꜳ': 'aa',
    'æ': 'ae',
    'ǽ': 'ae',
    'ǣ': 'ae',
    'ꜵ': 'ao',
    'ꜷ': 'au',
    'ꜹ': 'av',
    'ꜻ': 'av',
    'ꜽ': 'ay',
    'ḃ': 'b',
    'ḅ': 'b',
    'ɓ': 'b',
    'ḇ': 'b',
    'ᵬ': 'b',
    'ᶀ': 'b',
    'ƀ': 'b',
    'ƃ': 'b',
    'ɵ': 'o',
    'ć': 'c',
    'č': 'c',
    'ç': 'c',
    'ḉ': 'c',
    'ĉ': 'c',
    'ɕ': 'c',
    'ċ': 'c',
    'ƈ': 'c',
    'ȼ': 'c',
    'ď': 'd',
    'ḑ': 'd',
    'ḓ': 'd',
    'ȡ': 'd',
    'ḋ': 'd',
    'ḍ': 'd',
    'ɗ': 'd',
    'ᶑ': 'd',
    'ḏ': 'd',
    'ᵭ': 'd',
    'ᶁ': 'd',
    'đ': 'd',
    'ɖ': 'd',
    'ƌ': 'd',
    'ı': 'i',
    'ȷ': 'j',
    'ɟ': 'j',
    'ʄ': 'j',
    'ǳ': 'dz',
    'ǆ': 'dz',
    'é': 'e',
    'ĕ': 'e',
    'ě': 'e',
    'ȩ': 'e',
    'ḝ': 'e',
    'ê': 'e',
    'ế': 'e',
    'ệ': 'e',
    'ề': 'e',
    'ể': 'e',
    'ễ': 'e',
    'ḙ': 'e',
    'ë': 'e',
    'ė': 'e',
    'ẹ': 'e',
    'ȅ': 'e',
    'è': 'e',
    'ẻ': 'e',
    'ȇ': 'e',
    'ē': 'e',
    'ḗ': 'e',
    'ḕ': 'e',
    'ⱸ': 'e',
    'ę': 'e',
    'ᶒ': 'e',
    'ɇ': 'e',
    'ẽ': 'e',
    'ḛ': 'e',
    'ꝫ': 'et',
    'ḟ': 'f',
    'ƒ': 'f',
    'ᵮ': 'f',
    'ᶂ': 'f',
    'ǵ': 'g',
    'ğ': 'g',
    'ǧ': 'g',
    'ģ': 'g',
    'ĝ': 'g',
    'ġ': 'g',
    'ɠ': 'g',
    'ḡ': 'g',
    'ᶃ': 'g',
    'ǥ': 'g',
    'ḫ': 'h',
    'ȟ': 'h',
    'ḩ': 'h',
    'ĥ': 'h',
    'ⱨ': 'h',
    'ḧ': 'h',
    'ḣ': 'h',
    'ḥ': 'h',
    'ɦ': 'h',
    'ẖ': 'h',
    'ħ': 'h',
    'ƕ': 'hv',
    'í': 'i',
    'ĭ': 'i',
    'ǐ': 'i',
    'î': 'i',
    'ï': 'i',
    'ḯ': 'i',
    'ị': 'i',
    'ȉ': 'i',
    'ì': 'i',
    'ỉ': 'i',
    'ȋ': 'i',
    'ī': 'i',
    'į': 'i',
    'ᶖ': 'i',
    'ɨ': 'i',
    'ĩ': 'i',
    'ḭ': 'i',
    'ꝺ': 'd',
    'ꝼ': 'f',
    'ᵹ': 'g',
    'ꞃ': 'r',
    'ꞅ': 's',
    'ꞇ': 't',
    'ꝭ': 'is',
    'ǰ': 'j',
    'ĵ': 'j',
    'ʝ': 'j',
    'ɉ': 'j',
    'ḱ': 'k',
    'ǩ': 'k',
    'ķ': 'k',
    'ⱪ': 'k',
    'ꝃ': 'k',
    'ḳ': 'k',
    'ƙ': 'k',
    'ḵ': 'k',
    'ᶄ': 'k',
    'ꝁ': 'k',
    'ꝅ': 'k',
    'ĺ': 'l',
    'ƚ': 'l',
    'ɬ': 'l',
    'ľ': 'l',
    'ļ': 'l',
    'ḽ': 'l',
    'ȴ': 'l',
    'ḷ': 'l',
    'ḹ': 'l',
    'ⱡ': 'l',
    'ꝉ': 'l',
    'ḻ': 'l',
    'ŀ': 'l',
    'ɫ': 'l',
    'ᶅ': 'l',
    'ɭ': 'l',
    'ł': 'l',
    'ǉ': 'lj',
    'ſ': 's',
    'ẜ': 's',
    'ẛ': 's',
    'ẝ': 's',
    'ḿ': 'm',
    'ṁ': 'm',
    'ṃ': 'm',
    'ɱ': 'm',
    'ᵯ': 'm',
    'ᶆ': 'm',
    'ń': 'n',
    'ň': 'n',
    'ņ': 'n',
    'ṋ': 'n',
    'ȵ': 'n',
    'ṅ': 'n',
    'ṇ': 'n',
    'ǹ': 'n',
    'ɲ': 'n',
    'ṉ': 'n',
    'ƞ': 'n',
    'ᵰ': 'n',
    'ᶇ': 'n',
    'ɳ': 'n',
    'ñ': 'n',
    'ǌ': 'nj',
    'ó': 'o',
    'ŏ': 'o',
    'ǒ': 'o',
    'ô': 'o',
    'ố': 'o',
    'ộ': 'o',
    'ồ': 'o',
    'ổ': 'o',
    'ỗ': 'o',
    'ö': 'o',
    'ȫ': 'o',
    'ȯ': 'o',
    'ȱ': 'o',
    'ọ': 'o',
    'ő': 'o',
    'ȍ': 'o',
    'ò': 'o',
    'ỏ': 'o',
    'ơ': 'o',
    'ớ': 'o',
    'ợ': 'o',
    'ờ': 'o',
    'ở': 'o',
    'ỡ': 'o',
    'ȏ': 'o',
    'ꝋ': 'o',
    'ꝍ': 'o',
    'ⱺ': 'o',
    'ō': 'o',
    'ṓ': 'o',
    'ṑ': 'o',
    'ǫ': 'o',
    'ǭ': 'o',
    'ø': 'o',
    'ǿ': 'o',
    'õ': 'o',
    'ṍ': 'o',
    'ṏ': 'o',
    'ȭ': 'o',
    'ƣ': 'oi',
    'ꝏ': 'oo',
    'ɛ': 'e',
    'ᶓ': 'e',
    'ɔ': 'o',
    'ᶗ': 'o',
    'ȣ': 'ou',
    'ṕ': 'p',
    'ṗ': 'p',
    'ꝓ': 'p',
    'ƥ': 'p',
    'ᵱ': 'p',
    'ᶈ': 'p',
    'ꝕ': 'p',
    'ᵽ': 'p',
    'ꝑ': 'p',
    'ꝙ': 'q',
    'ʠ': 'q',
    'ɋ': 'q',
    'ꝗ': 'q',
    'ŕ': 'r',
    'ř': 'r',
    'ŗ': 'r',
    'ṙ': 'r',
    'ṛ': 'r',
    'ṝ': 'r',
    'ȑ': 'r',
    'ɾ': 'r',
    'ᵳ': 'r',
    'ȓ': 'r',
    'ṟ': 'r',
    'ɼ': 'r',
    'ᵲ': 'r',
    'ᶉ': 'r',
    'ɍ': 'r',
    'ɽ': 'r',
    'ↄ': 'c',
    'ꜿ': 'c',
    'ɘ': 'e',
    'ɿ': 'r',
    'ś': 's',
    'ṥ': 's',
    'š': 's',
    'ṧ': 's',
    'ş': 's',
    'ŝ': 's',
    'ș': 's',
    'ṡ': 's',
    'ṣ': 's',
    'ṩ': 's',
    'ʂ': 's',
    'ᵴ': 's',
    'ᶊ': 's',
    'ȿ': 's',
    'ɡ': 'g',
    'ᴑ': 'o',
    'ᴓ': 'o',
    'ᴝ': 'u',
    'ť': 't',
    'ţ': 't',
    'ṱ': 't',
    'ț': 't',
    'ȶ': 't',
    'ẗ': 't',
    'ⱦ': 't',
    'ṫ': 't',
    'ṭ': 't',
    'ƭ': 't',
    'ṯ': 't',
    'ᵵ': 't',
    'ƫ': 't',
    'ʈ': 't',
    'ŧ': 't',
    'ᵺ': 'th',
    'ɐ': 'a',
    'ᴂ': 'ae',
    'ǝ': 'e',
    'ᵷ': 'g',
    'ɥ': 'h',
    'ʮ': 'h',
    'ʯ': 'h',
    'ᴉ': 'i',
    'ʞ': 'k',
    'ꞁ': 'l',
    'ɯ': 'm',
    'ɰ': 'm',
    'ᴔ': 'oe',
    'ɹ': 'r',
    'ɻ': 'r',
    'ɺ': 'r',
    'ⱹ': 'r',
    'ʇ': 't',
    'ʌ': 'v',
    'ʍ': 'w',
    'ʎ': 'y',
    'ꜩ': 'tz',
    'ú': 'u',
    'ŭ': 'u',
    'ǔ': 'u',
    'û': 'u',
    'ṷ': 'u',
    'ü': 'u',
    'ǘ': 'u',
    'ǚ': 'u',
    'ǜ': 'u',
    'ǖ': 'u',
    'ṳ': 'u',
    'ụ': 'u',
    'ű': 'u',
    'ȕ': 'u',
    'ù': 'u',
    'ủ': 'u',
    'ư': 'u',
    'ứ': 'u',
    'ự': 'u',
    'ừ': 'u',
    'ử': 'u',
    'ữ': 'u',
    'ȗ': 'u',
    'ū': 'u',
    'ṻ': 'u',
    'ų': 'u',
    'ᶙ': 'u',
    'ů': 'u',
    'ũ': 'u',
    'ṹ': 'u',
    'ṵ': 'u',
    'ᵫ': 'ue',
    'ꝸ': 'um',
    'ⱴ': 'v',
    'ꝟ': 'v',
    'ṿ': 'v',
    'ʋ': 'v',
    'ᶌ': 'v',
    'ⱱ': 'v',
    'ṽ': 'v',
    'ꝡ': 'vy',
    'ẃ': 'w',
    'ŵ': 'w',
    'ẅ': 'w',
    'ẇ': 'w',
    'ẉ': 'w',
    'ẁ': 'w',
    'ⱳ': 'w',
    'ẘ': 'w',
    'ẍ': 'x',
    'ẋ': 'x',
    'ᶍ': 'x',
    'ý': 'y',
    'ŷ': 'y',
    'ÿ': 'y',
    'ẏ': 'y',
    'ỵ': 'y',
    'ỳ': 'y',
    'ƴ': 'y',
    'ỷ': 'y',
    'ỿ': 'y',
    'ȳ': 'y',
    'ẙ': 'y',
    'ɏ': 'y',
    'ỹ': 'y',
    'ź': 'z',
    'ž': 'z',
    'ẑ': 'z',
    'ʑ': 'z',
    'ⱬ': 'z',
    'ż': 'z',
    'ẓ': 'z',
    'ȥ': 'z',
    'ẕ': 'z',
    'ᵶ': 'z',
    'ᶎ': 'z',
    'ʐ': 'z',
    'ƶ': 'z',
    'ɀ': 'z',
    'ﬀ': 'ff',
    'ﬃ': 'ffi',
    'ﬄ': 'ffl',
    'ﬁ': 'fi',
    'ﬂ': 'fl',
    'ĳ': 'ij',
    'œ': 'oe',
    'ﬆ': 'st',
    'ₐ': 'a',
    'ₑ': 'e',
    'ᵢ': 'i',
    'ⱼ': 'j',
    'ₒ': 'o',
    'ᵣ': 'r',
    'ᵤ': 'u',
    'ᵥ': 'v',
    'ₓ': 'x',
    'Ё': 'YO',
    'Й': 'I',
    'Ц': 'TS',
    'У': 'U',
    'К': 'K',
    'Е': 'E',
    'Н': 'N',
    'Г': 'G',
    'Ш': 'SH',
    'Щ': 'SCH',
    'З': 'Z',
    'Х': 'H',
    'Ъ': "'",
    'ё': 'yo',
    'й': 'i',
    'ц': 'ts',
    'у': 'u',
    'к': 'k',
    'е': 'e',
    'н': 'n',
    'г': 'g',
    'ш': 'sh',
    'щ': 'sch',
    'з': 'z',
    'х': 'h',
    'ъ': "'",
    'Ф': 'F',
    'Ы': 'I',
    'В': 'V',
    'А': 'a',
    'П': 'P',
    'Р': 'R',
    'О': 'O',
    'Л': 'L',
    'Д': 'D',
    'Ж': 'ZH',
    'Э': 'E',
    'ф': 'f',
    'ы': 'i',
    'в': 'v',
    'а': 'a',
    'п': 'p',
    'р': 'r',
    'о': 'o',
    'л': 'l',
    'д': 'd',
    'ж': 'zh',
    'э': 'e',
    'Я': 'Ya',
    'Ч': 'CH',
    'С': 'S',
    'М': 'M',
    'И': 'I',
    'Т': 'T',
    'Ь': "'",
    'Б': 'B',
    'Ю': 'YU',
    'я': 'ya',
    'ч': 'ch',
    'с': 's',
    'м': 'm',
    'и': 'i',
    'т': 't',
    'ь': "'",
    'б': 'b',
    'ю': 'yu'
  };

  return latinize;
});

/***/ }),

/***/ "k4Pk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/styled-components/dist/styled-components.es.js
var styled_components_es = __webpack_require__("X5xa");

// EXTERNAL MODULE: ../node_modules/latinize/latinize.js
var latinize = __webpack_require__("aFu/");
var latinize_default = /*#__PURE__*/__webpack_require__.n(latinize);

// EXTERNAL MODULE: ./components/atoms/sizer.js
var sizer = __webpack_require__("IgyU");

// CONCATENATED MODULE: ./components/atoms/vspace.js
var _templateObject = _taggedTemplateLiteralLoose(['\n  height: 50px;\n'], ['\n  height: 50px;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }



/* harmony default export */ var vspace = (styled_components_es["a" /* default */].div(_templateObject));
// EXTERNAL MODULE: ./components/atoms/underlined.js
var underlined = __webpack_require__("eYvj");

// CONCATENATED MODULE: ./routes/home/resultcard.js
var resultcard__templateObject = resultcard__taggedTemplateLiteralLoose(['\n  width: 100%;\n  height: 160px;\n  background-color: white;\n  display: inline-block;\n  text-align: center;\n  position: relative;\n  padding-top: 30px;\n  color: black;\n  text-decoration: none;\n  transition: background-color 0.2s;\n  :hover {\n    background-color: #eee;\n  }\n'], ['\n  width: 100%;\n  height: 160px;\n  background-color: white;\n  display: inline-block;\n  text-align: center;\n  position: relative;\n  padding-top: 30px;\n  color: black;\n  text-decoration: none;\n  transition: background-color 0.2s;\n  :hover {\n    background-color: #eee;\n  }\n']),
    _templateObject2 = resultcard__taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 9px;\n  background-color: ', ';\n  width: ', '%;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 9px;\n  background-color: ', ';\n  width: ', '%;\n']),
    _templateObject3 = resultcard__taggedTemplateLiteralLoose(['\n  font-weight: bold;\n'], ['\n  font-weight: bold;\n']),
    _templateObject4 = resultcard__taggedTemplateLiteralLoose(['\n  width: 237px;\n  padding: 0 1px 1px 0;\n  :hover ', '::after {\n    opacity: 0;\n  }\n'], ['\n  width: 237px;\n  padding: 0 1px 1px 0;\n  :hover ', '::after {\n    opacity: 0;\n  }\n']);



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function resultcard__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }





var Card = styled_components_es["a" /* default */].a(resultcard__templateObject);

function percentToColor(v) {
  if (v < 20) return 'rgb(221, 30, 34)';
  if (v < 50) return 'rgb(235, 168, 8)';
  if (v < 80) return 'rgb(146, 200, 72)';
  return 'rgb(67, 113, 26)';
}

var Bar = styled_components_es["a" /* default */].div(_templateObject2, function (props) {
  return percentToColor(props.percent);
}, function (props) {
  return props.percent;
});

var Name = underlined["a" /* default */].extend(_templateObject3);

var CardOuter = styled_components_es["a" /* default */].div(_templateObject4, Name);

var resultcard_ResultCard = function (_Component) {
  _inherits(ResultCard, _Component);

  function ResultCard() {
    _classCallCheck(this, ResultCard);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ResultCard.prototype.render = function render(_ref) {
    var percent = _ref.percent,
        name = _ref.name,
        surname = _ref.surname,
        party = _ref.party,
        id = _ref.id;

    return Object(preact_min["h"])(
      CardOuter,
      null,
      Object(preact_min["h"])(
        Card,
        { href: '/hlas/' + id },
        Object(preact_min["h"])(Bar, { percent: percent }),
        Object(preact_min["h"])(
          'div',
          null,
          percent === false ? '-' : percent + '%'
        ),
        Object(preact_min["h"])(
          'div',
          null,
          Object(preact_min["h"])(
            Name,
            null,
            name.trim()
          )
        ),
        Object(preact_min["h"])(
          'div',
          null,
          Object(preact_min["h"])(
            Name,
            null,
            surname.trim()
          )
        ),
        Object(preact_min["h"])(
          'div',
          null,
          party
        )
      )
    );
  };

  return ResultCard;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./routes/home/resultcardcontainer.js
var resultcardcontainer__templateObject = resultcardcontainer__taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n'], ['\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n']);

function resultcardcontainer__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }



/* harmony default export */ var resultcardcontainer = (styled_components_es["a" /* default */].div(resultcardcontainer__templateObject));
// EXTERNAL MODULE: ./components/atoms/spinner.js
var spinner = __webpack_require__("hC2H");

// EXTERNAL MODULE: ./components/atoms/select/select.png
var select_select = __webpack_require__("Yk1m");
var select_default = /*#__PURE__*/__webpack_require__.n(select_select);

// CONCATENATED MODULE: ./components/atoms/select/select.js
var select__templateObject = select__taggedTemplateLiteralLoose(['\n  box-sizing: content-box;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  text-indent: 10px;\n  padding: 2px 31px 2px 4px;\n  width: ', 'px;\n  height: 34px;\n  box-shadow: none;\n  background: #fff url(', ') right 0 no-repeat;\n  appearance: none;\n\n  margin: ', ';\n  border: ', ';\n\n  font-family: \'chaparral-pro\', serif;\n  font-size: 18px;\n  line-height: 40px;\n  cursor: pointer;\n  outline: none;\n  :focus {\n    margin: 0px 0px 20px 0px;\n    border: 1px solid ', ';\n  }\n  :-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 #000;\n  }\n'], ['\n  box-sizing: content-box;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  text-indent: 10px;\n  padding: 2px 31px 2px 4px;\n  width: ', 'px;\n  height: 34px;\n  box-shadow: none;\n  background: #fff url(', ') right 0 no-repeat;\n  appearance: none;\n\n  margin: ', ';\n  border: ', ';\n\n  font-family: \'chaparral-pro\', serif;\n  font-size: 18px;\n  line-height: 40px;\n  cursor: pointer;\n  outline: none;\n  :focus {\n    margin: 0px 0px 20px 0px;\n    border: 1px solid ', ';\n  }\n  :-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 #000;\n  }\n']),
    select__templateObject2 = select__taggedTemplateLiteralLoose([''], ['']);



function select__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }





var Select = styled_components_es["a" /* default */].select(select__templateObject, function (props) {
  return props.width || 306;
}, select_default.a, function (props) {
  return props.error ? '0px 0px 20px 0px' : '1px 1px 21px 1px';
}, function (props) {
  return props.error ? '1px solid #fa4624' : 0;
}, function (props) {
  return props.error ? '#fa4624' : '#4d90fe';
});

var Option = styled_components_es["a" /* default */].option(select__templateObject2);

/*
<Box
  {...getInputProps()}
  type="button"
  onClick={toggleMenu}
  data-toggle="dropdown"
  aria-haspopup="true"
  aria-expanded={isOpen}
>
  {selectedItem || props.default || 'Select an item'}
</Box>
*/

function Dropdown(props) {
  var items = props.items,
      _onChange = props.onChange;

  return Object(preact_min["h"])(
    Select,
    {
      onChange: function onChange(evt) {
        return _onChange(evt.target.value);
      },
      width: props.width,
      className: props.className
    },
    items.map(function (item) {
      return Object(preact_min["h"])(
        Option,
        {
          selected: props.value === item.key,
          key: item.key,
          value: item.key
        },
        item.display
      );
    })
  );
}
// EXTERNAL MODULE: ./components/atoms/input.js
var input = __webpack_require__("p+KG");

// EXTERNAL MODULE: ./components/atoms/checkbox/arrow.svg
var arrow = __webpack_require__("bxWs");
var arrow_default = /*#__PURE__*/__webpack_require__.n(arrow);

// CONCATENATED MODULE: ./components/atoms/checkbox/arrowCheckbox.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var arrowCheckbox__templateObject = arrowCheckbox__taggedTemplateLiteralLoose(['\n  width: 40px;\n  height: 40px;\n  overflow: hidden;\n  position: absolute;\n  vertical-align: middle;\n  margin: 0px;\n  background: transparent;\n  opacity: 0;\n  outline: none;\n\n  + div {\n    vertical-align: middle;\n    display: inline-block;\n    width: 40px;\n    height: 40px;\n    border: 1px solid transparent;\n    position: absolute;\n    background: #353f4b;\n    + div {\n      width: 40px;\n      height: 40px;\n      background: url(', ') center no-repeat;\n      transform: ', ';\n      transition: transform 0.5s ease-in-out;\n    }\n  }\n  :focus + div {\n    border: 1px solid ', ';\n  }\n'], ['\n  width: 40px;\n  height: 40px;\n  overflow: hidden;\n  position: absolute;\n  vertical-align: middle;\n  margin: 0px;\n  background: transparent;\n  opacity: 0;\n  outline: none;\n\n  + div {\n    vertical-align: middle;\n    display: inline-block;\n    width: 40px;\n    height: 40px;\n    border: 1px solid transparent;\n    position: absolute;\n    background: #353f4b;\n    + div {\n      width: 40px;\n      height: 40px;\n      background: url(', ') center no-repeat;\n      transform: ', ';\n      transition: transform 0.5s ease-in-out;\n    }\n  }\n  :focus + div {\n    border: 1px solid ', ';\n  }\n']),
    arrowCheckbox__templateObject2 = arrowCheckbox__taggedTemplateLiteralLoose(['\n  width: 40px;\n  height: 40px;\n  display: inline-block;\n  margin-left: 20px;\n'], ['\n  width: 40px;\n  height: 40px;\n  display: inline-block;\n  margin-left: 20px;\n']);



function arrowCheckbox__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }





var ArrowCheckbox = styled_components_es["a" /* default */].input(arrowCheckbox__templateObject, arrow_default.a, function (props) {
  return props.checked ? 'rotate(0deg)' : 'rotate(180deg)';
}, function (props) {
  return props.error ? '#fa4624' : '#4d90fe';
});

var Container = styled_components_es["a" /* default */].div(arrowCheckbox__templateObject2);

var arrowCheckbox__ref = Object(preact_min["h"])('div', null);

var arrowCheckbox__ref2 = Object(preact_min["h"])('div', null);

/* harmony default export */ var arrowCheckbox = (function (props) {
  return Object(preact_min["h"])(
    Container,
    null,
    Object(preact_min["h"])(ArrowCheckbox, _extends({}, props, { checked: props.checked })),
    arrowCheckbox__ref,
    arrowCheckbox__ref2
  );
});
// EXTERNAL MODULE: ./utils/fetcher.js
var fetcher = __webpack_require__("r/rX");

// EXTERNAL MODULE: ./routes/home/in-parliament.png
var in_parliament = __webpack_require__("qQn4");
var in_parliament_default = /*#__PURE__*/__webpack_require__.n(in_parliament);

// EXTERNAL MODULE: ./routes/home/cross-black.png
var cross_black = __webpack_require__("0w4T");
var cross_black_default = /*#__PURE__*/__webpack_require__.n(cross_black);

// EXTERNAL MODULE: ./routes/home/tick-black.png
var tick_black = __webpack_require__("sfH+");
var tick_black_default = /*#__PURE__*/__webpack_require__.n(tick_black);

// EXTERNAL MODULE: ./data/index.mjs
var data = __webpack_require__("nCyS");

// CONCATENATED MODULE: ../node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/jakub.skorepa/president/node_modules/babel-preset-env/lib/index.js",{"loose":true,"uglify":true,"modules":false,"targets":{"browsers":["> 1%","last 2 versions","IE >= 9"]},"exclude":["transform-regenerator","transform-es2015-typeof-symbol"]}],"/home/jakub.skorepa/president/node_modules/babel-preset-stage-1/lib/index.js"],"plugins":["/home/jakub.skorepa/president/node_modules/babel-plugin-transform-object-assign/lib/index.js","/home/jakub.skorepa/president/node_modules/babel-plugin-transform-decorators-legacy/lib/index.js","/home/jakub.skorepa/president/node_modules/babel-plugin-transform-react-constant-elements/lib/index.js","/home/jakub.skorepa/president/node_modules/babel-plugin-transform-react-remove-prop-types/lib/index.js",["/home/jakub.skorepa/president/node_modules/babel-plugin-transform-react-jsx/lib/index.js",{"pragma":"h"}],["/home/jakub.skorepa/president/node_modules/babel-plugin-jsx-pragmatic/jsx-pragmatic.js",{"module":"preact","export":"h","import":"h"}]]}!./routes/home/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return home_Home; });
var home__templateObject = home__taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n'], ['\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n']),
    home__templateObject2 = home__taggedTemplateLiteralLoose(['\n  margin-left: 20px;\n  display: inline-block;\n  width: 308px;\n'], ['\n  margin-left: 20px;\n  display: inline-block;\n  width: 308px;\n']),
    home__templateObject3 = home__taggedTemplateLiteralLoose(['\n  text-align: center;\n  font-size: 32px;\n  font-weight: bold;\n  margin-bottom: 24px;\n'], ['\n  text-align: center;\n  font-size: 32px;\n  font-weight: bold;\n  margin-bottom: 24px;\n']),
    home__templateObject4 = home__taggedTemplateLiteralLoose(['\n  position: absolute;\n  width: 100%;\n  max-width: 950px;\n  img {\n    position: absolute;\n    right: -80px;\n    top: -125px;\n  }\n  @media only screen and (max-width: 1135px) {\n    display: none;\n    opacity: 0;\n  }\n'], ['\n  position: absolute;\n  width: 100%;\n  max-width: 950px;\n  img {\n    position: absolute;\n    right: -80px;\n    top: -125px;\n  }\n  @media only screen and (max-width: 1135px) {\n    display: none;\n    opacity: 0;\n  }\n']),
    _templateObject5 = home__taggedTemplateLiteralLoose(['\n  max-width: 780px;\n  padding: 0 10px;\n  margin: 0 auto;\n  font-size: 21px;\n  line-height: 30px;\n  text-align: justify;\n'], ['\n  max-width: 780px;\n  padding: 0 10px;\n  margin: 0 auto;\n  font-size: 21px;\n  line-height: 30px;\n  text-align: justify;\n']),
    _templateObject6 = home__taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: space-evenly;\n  flex-wrap: wrap;\n  max-width: 780px;\n  margin: 0 auto 42px auto;\n  img {\n    vertical-align: middle;\n    margin: 0 10px 0 10px;\n  }\n'], ['\n  display: flex;\n  justify-content: space-evenly;\n  flex-wrap: wrap;\n  max-width: 780px;\n  margin: 0 auto 42px auto;\n  img {\n    vertical-align: middle;\n    margin: 0 10px 0 10px;\n  }\n']);



function home__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function home__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function home__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function home__taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }


















/* global history */
/* eslint-disable react/no-unused-state, no-restricted-globals */

function replaceState(a, b, c) {
  if (typeof history !== 'undefined') {
    history.replaceState(a, b, c);
  }
}

var Filters = styled_components_es["a" /* default */].div(home__templateObject);

var NameInput = input["a" /* default */].extend(home__templateObject2);

var Title = styled_components_es["a" /* default */].p(home__templateObject3);

function votesToParties(v) {
  var partyCounts = {};
  return v.map(function (a) {
    return a.party;
  }).filter(function (value, index, self) {
    if (!partyCounts[value]) partyCounts[value] = 0;
    partyCounts[value] += 1;
    return self.indexOf(value) === index;
  }).map(function (party) {
    return { party: party, count: partyCounts[party] };
  });
}

var home__ref = Object(preact_min["h"])('img', { src: in_parliament_default.a, alt: 'Tito u\u017E jsou ve sn\u011Bmovn\u011B' });

var InParliament = Object(styled_components_es["a" /* default */])(function (p) {
  return Object(preact_min["h"])(
    'div',
    p,
    home__ref
  );
})(home__templateObject4);

var Explainer = styled_components_es["a" /* default */].p(_templateObject5);

var ExplainerGraphic = styled_components_es["a" /* default */].div(_templateObject6);

var _ref4 = Object(preact_min["h"])(
  Title,
  null,
  'Podpora opat\u0159en\xED'
);

var _ref5 = Object(preact_min["h"])(
  ExplainerGraphic,
  null,
  Object(preact_min["h"])(
    'div',
    null,
    Object(preact_min["h"])('img', { alt: '', src: cross_black_default.a }),
    'proti korupci'
  ),
  Object(preact_min["h"])(
    'div',
    null,
    Object(preact_min["h"])('img', { alt: '', src: cross_black_default.a }),
    'proti pl\xFDtv\xE1n\xED ve\u0159ejn\xFDmi pen\u011Bzi'
  ),
  Object(preact_min["h"])(
    'div',
    null,
    Object(preact_min["h"])('img', { alt: '', src: tick_black_default.a }),
    'pro otev\u0159enost ve\u0159ejn\xE9 spr\xE1vy'
  )
);

var _ref6 = Object(preact_min["h"])(spinner["a" /* default */], null);

var _ref7 = Object(preact_min["h"])(vspace, null);

var _ref8 = Object(preact_min["h"])(InParliament, null);

var home_Home = function (_Component) {
  home__inherits(Home, _Component);

  function Home() {
    var _temp, _this, _ret;

    home__classCallCheck(this, Home);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = home__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      votes: false,
      parties: false,
      downloading: false,
      sort: undefined,
      party: undefined,
      name: undefined
    }, _temp), home__possibleConstructorReturn(_this, _ret);
  }

  Home.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.all !== nextProps.all) {
      this.setState({
        votes: false,
        sort: undefined,
        party: undefined,
        name: undefined
      });
    }
  };

  Home.prototype.render = function render(_ref2, _ref3) {
    var _this2 = this;

    var query = _ref2.query,
        aAll = _ref2.all;
    var votes = _ref3.votes,
        downloading = _ref3.downloading;

    var all = aAll || Object(data["b" /* getType */])() !== 'mop';
    var path = all ? '/vsichni' : '/';

    if (!votes && !downloading && typeof window !== 'undefined') {
      this.setState({ downloading: true });
      Object(fetcher["a" /* default */])({
        path: all ? '/api/votes/all' : '/api/votes',
        onData: function onData(v) {
          _this2.setState({
            votes: v.concat(Object(data["b" /* getType */])() === 'president' ? [{
              id: 6,
              name: 'Jiří',
              surname: 'Hynek',
              party: '',
              percent: false,
              is_in_parliament: null
            }, {
              id: 9,
              name: 'Miloš',
              surname: 'Zeman',
              party: '',
              percent: false,
              is_in_parliament: null
            }, {
              id: 2,
              name: 'Jiří',
              surname: 'Drahoš',
              party: '',
              percent: false,
              is_in_parliament: null
            }] : []),
            parties: votesToParties(v),
            downloading: false
          });
        }
      });
    }

    function override(a, b) {
      return a !== undefined ? a : b !== undefined ? b : false;
    }

    var name = override(this.state.name, query.name);
    var party = override(this.state.party, query.party);
    var sort = override(this.state.sort, query.sort === 'asc' ? -1 : false) || 1;

    function sortParam() {
      var amp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (sort === 1) return '';
      return amp + 'sort=asc';
    }

    return Object(preact_min["h"])(
      sizer["a" /* default */],
      null,
      _ref4,
      _ref5,
      Object(preact_min["h"])(
        Explainer,
        null,
        'Zeptali jsme se kandid\xE1t\u016F',
        ' ',
        Object(data["b" /* getType */])() === 'mop' ? 'do Sněmovny' : 'na prezidenta',
        ', jak\xE1 opat\u0159en\xED podporuj\xED a jak\xE1 nikoli. V dotazn\xEDku jsme uvedli body, na jejich\u017E pot\u0159ebnosti se shodla skupina expert\u016F. N\xED\u017Ee uv\xE1d\xEDme p\u0159ehled politik\u016F,',
        all ? '' : ' kteří se do Sněmovny dostali a',
        ' kte\u0159\xED dotazn\xEDk vyplnili.'
      ),
      !votes ? _ref6 : Object(preact_min["h"])(
        'div',
        null,
        _ref7,
        Object(preact_min["h"])(
          Filters,
          null,
          Object(data["b" /* getType */])() !== 'mop' ? null : Object(preact_min["h"])(Dropdown, {
            value: party,
            onChange: function onChange(pty) {
              if (pty === 'Všechny strany') {
                replaceState({}, '', path + sortParam('?'));
                _this2.setState({ party: false });
              } else {
                replaceState({}, '', path + '?party=' + pty + sortParam('&'));
                _this2.setState({ party: pty, name: false });
              }
            },
            'default': 'V\u0161echny strany',
            items: [{ key: false, display: 'Všechny strany' }].concat(this.state.parties.sort(function (a, b) {
              return a.count === b.count ? a.party.localeCompare(b.party, 'cs') : a.count < b.count ? 1 : -1;
            }).map(function (p) {
              return {
                key: p.party,
                display: p.party + ' (' + p.count + ')'
              };
            }))
          }),
          Object(preact_min["h"])(NameInput, {
            placeholder: 'Jm\xE9no politika',
            value: name || '',
            onChange: function onChange(evt) {
              var val = evt.target.value;
              if (val) {
                replaceState({}, '', path + '?name=' + val + sortParam('&'));
                _this2.setState({ name: val, party: false });
              } else {
                replaceState({}, '', path + sortParam('?'));
                _this2.setState({ name: val });
              }
            }
          }),
          Object(data["b" /* getType */])() !== 'mop' ? null : Object(preact_min["h"])(
            'label',
            null,
            Object(preact_min["h"])(arrowCheckbox, {
              checked: sort < 0,
              type: 'checkbox',
              onChange: function onChange() {
                var newSortParam = function newSortParam() {
                  var amp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                  return sort > 0 ? amp + 'sort=asc' : '';
                };
                if (name) {
                  replaceState({}, '', path + '?name=' + name + newSortParam('&'));
                } else if (party) {
                  replaceState({}, '', path + '?party=' + party + newSortParam('&'));
                } else {
                  replaceState({}, '', path + newSortParam('?'));
                }
                if (sort > 0) {
                  _this2.setState({ sort: -1 });
                } else {
                  _this2.setState({ sort: 1 });
                }
              }
            })
          )
        ),
        all || Object(data["b" /* getType */])() !== 'mop' ? null : _ref8,
        Object(preact_min["h"])(
          resultcardcontainer,
          null,
          (votes || []).filter(function (v) {
            return !party || v.party === party;
          }).filter(function (v) {
            return !name || latinize_default()(v.name + ' ' + v.surname).toLowerCase().indexOf(latinize_default()(name).toLowerCase()) > -1;
          }).sort(function (a, b) {
            return a.percent === b.percent ? a.surname.localeCompare(b.surname, 'cs') : a.percent < b.percent ? sort : -sort;
          }).map(function (r) {
            return Object(preact_min["h"])(resultcard_ResultCard, r);
          })
        )
      )
    );
  };

  return Home;
}(preact_min["Component"]);



/***/ }),

/***/ "qQn4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6031e262482672d3b2a065ea8ab83712.png";

/***/ }),

/***/ "sfH+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "34b97b5b357590f62c5ddd130a8dc5d8.png";

/***/ })

});


// WEBPACK FOOTER //
// route-home.chunk.6ea27.js